/*
 * ネーム刺繍の料金はワークマン公式オンラインの名入れと完全同一の6帯（1行ごと・税込・枚数割引なし）。
 * 5文字以下¥360 / 6文字¥410 / 7文字¥460 / 8文字¥510 / 9文字¥560 / 10文字¥620。11文字以上は不可。
 * 文字高さは1.2cm固定。2行まで（行ごとに文字数別課金）。
 * ロゴ刺繍のデータ管理料¥3,000は名入れには存在しない（ワークマン実注文フロー・公式ガイド・第三者記事で裏取り済み）。
 * この料金ラダーの正はこのファイル。テーマ側(config JSON)は各帯のvariant IDのみを渡す。
 */
(function (global) {
  'use strict';

  var MAX_NAME_CHARACTERS = 10;

  // maxCharacters 昇順。getNameBandByLength は「length <= maxCharacters」を満たす最初の帯を返す。
  var namePriceBands = Object.freeze([
    Object.freeze({ code: 'NAME-H012-C05', heightCm: 1.2, maxCharacters: 5, unitPrice: 360 }),
    Object.freeze({ code: 'NAME-H012-C06', heightCm: 1.2, maxCharacters: 6, unitPrice: 410 }),
    Object.freeze({ code: 'NAME-H012-C07', heightCm: 1.2, maxCharacters: 7, unitPrice: 460 }),
    Object.freeze({ code: 'NAME-H012-C08', heightCm: 1.2, maxCharacters: 8, unitPrice: 510 }),
    Object.freeze({ code: 'NAME-H012-C09', heightCm: 1.2, maxCharacters: 9, unitPrice: 560 }),
    Object.freeze({ code: 'NAME-H012-C10', heightCm: 1.2, maxCharacters: 10, unitPrice: 620 })
  ]);

  function textLength(text) {
    if (typeof text !== 'string') return 0;
    return Array.from(text.trim()).length;
  }

  function isValidNameText(text) {
    var length = textLength(text);
    return length >= 1 && length <= MAX_NAME_CHARACTERS;
  }

  function isValidQty(qty) {
    return Number.isInteger(qty) && qty >= 1 && qty <= 100;
  }

  function getNameBandByLength(length) {
    if (!Number.isInteger(length) || length < 1 || length > MAX_NAME_CHARACTERS) return null;

    return (
      namePriceBands.find(function (band) {
        return length <= band.maxCharacters;
      }) || null
    );
  }

  function getNameBand(text) {
    return getNameBandByLength(textLength(text));
  }

  function getNameUnitPriceByLength(length) {
    var band = getNameBandByLength(length);
    if (!band) {
      throw new RangeError('length must be an integer between 1 and ' + MAX_NAME_CHARACTERS + '.');
    }
    return band.unitPrice;
  }

  function getNameUnitPrice(text) {
    var band = getNameBand(text);
    if (!band) {
      throw new RangeError('text length must be between 1 and ' + MAX_NAME_CHARACTERS + ' characters.');
    }
    return band.unitPrice;
  }

  global.EmbroideryPricingCore = Object.freeze({
    MAX_NAME_CHARACTERS: MAX_NAME_CHARACTERS,
    namePriceBands: namePriceBands,
    textLength: textLength,
    isValidNameText: isValidNameText,
    isValidQty: isValidQty,
    getNameBandByLength: getNameBandByLength,
    getNameBand: getNameBand,
    getNameUnitPriceByLength: getNameUnitPriceByLength,
    getNameUnitPrice: getNameUnitPrice
  });
})(window);
